module.exports = require('./helpers/bundle-url').getBundleURL('9p9yL') + "Pressuru.684952ea.ttf";